<template>
  <div class="mobile-unavailable">
    <div class="notice-panel">
      <div class="notice-icon">
        <i class="el-icon-warning-outline"></i>
      </div>
      <h1>请使用PC端访问</h1>
      <p>如需办理登记申请，请登录PC端网站。</p>
      <p>
        如需了解DCI数字版权登记事项和登记流程，请点击：
        <a
          href="https://www.kdocs.cn/l/cvbV9ITu3mW6"
          target="_blank"
          rel="noopener noreferrer"
        >登记指南</a>
      </p>
      <p>
        或点击
        <a
          href="https://work.weixin.qq.com/kfid/kfcad9257946a973446"
          target="_blank"
          rel="noopener noreferrer"
        >人工服务</a>
        获得帮助。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileUnavailable'
}
</script>

<style lang="scss" scoped>
.mobile-unavailable {
  min-height: 100vh;
  padding: 40px 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
}

.notice-panel {
  width: 100%;
  max-width: 520px;
  padding: 32px 24px;
  box-sizing: border-box;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.08);
  color: #303133;
  text-align: left;
}

.notice-icon {
  margin-bottom: 16px;
  color: #e6a23c;
  font-size: 36px;
  text-align: center;
}

h1 {
  margin: 0 0 20px;
  font-size: 22px;
  line-height: 1.4;
  font-weight: 600;
  text-align: center;
  color: #303133;
}

p {
  margin: 12px 0 0;
  font-size: 15px;
  line-height: 1.8;
  color: #606266;
}

a {
  color: #409eff;
  font-weight: 600;
  text-decoration: none;
}
</style>
